module.exports = __webpack_public_path__ + "img/xander-2-creativo.bb0d1e65.png";